import React, { Component, ReactNode } from 'react'
import { connect } from "react-redux"
import trans from "trans"
import _sortBy from "lodash/sortBy"
import _find from "lodash/find"

import {
    css,
    Theme,
    Div,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import { ItemInterface, ReactSortable } from "react-sortablejs"

import { RandomProduct } from "shape-edit/types"
import {
    getFormName,
    reorderShapes,
    SOURCE_IMAGE_INDEX,
} from "shape-edit/forms/helpers";

import { iconDisabledColor } from "template-edit/components/tools-panel";

import { updateInputValue as change } from "app/reducers/form"
import { setActiveGroupId, setActiveShapeId, setActiveView } from "shape-edit/reducers";
import { selectLayers, toggleSelectLayer } from "../reducers";

import LayerGroupType from "shape-entities/types/layerGroup";
import ShapeListItem, { LayerPreview } from "./shape-list-item"
import SectionLoader from "app/components/section-loader";
import { SOURCE_IMAGE_TYPE } from 'shape-entities/types/shape'
import ClipMaskForm from 'shape-edit/forms/clip-mask-form'
import { selectFormValues } from 'app/reducers/form'
import { ACTIVE_VIEW_EDIT_SHAPE, ACTIVE_VIEW_EDIT_SOURCE_IMAGE, ACTIVE_VIEW_NEW_SHAPE } from 'template-edit/containers/Editor'
import ShapeListGroupItem from './shape-list-group-item'
import { sortBy } from 'lodash'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'
import { testUsers } from 'template-edit/components/helper'
import { ReduxList } from 'app/types/app-types'
import { Project } from 'app/types/model-types'

interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    randomProduct: RandomProduct
    project: ReduxList<Project>
    activeGroupId: string
    activeShapeId: string
    setActiveShapeId: typeof setActiveShapeId
    setActiveGroupId: typeof setActiveGroupId
    setActiveView: typeof setActiveView
    toggleSelectLayer: typeof toggleSelectLayer
    selectLayers: typeof selectLayers
    lockedLayers: string[]
    change: typeof change
    mouseOverShape: string
    setMouseOverShape: Function
}


class ShapeList extends Component<Props> {
    constructor(props) {
        super(props);
    }

    reorderShapesByPriority = () => {
        const { form } = this.props
        const shapesOrder = sortBy(Object.keys(form.shapes).map(idx => form.shapes[idx]), [(shape) => new Number(shape.priority)])
        reorderShapes(form.shapes, shapesOrder.map(shape => shape.index))
    }

    componentDidMount() {
        this.reorderShapesByPriority()
    }

    handleClickEvent = (event: MouseEvent, shapeIdx: string) => {
        const { activeShapeId } = this.props
        this.props.setActiveGroupId(null)
        if (event.ctrlKey) {
            if (activeShapeId) {
                this.props.toggleSelectLayer(activeShapeId)  //add active into group too
            }
            this.props.toggleSelectLayer(shapeIdx)
            this.props.setActiveShapeId(null)
        } else {
            this.props.setActiveShapeId(shapeIdx)
            this.props.selectLayers()
        }
    }

    handleEditEvent = (shapeIdx: string, event: MouseEvent) => {
        if (event.ctrlKey) {
            this.props.setActiveShapeId(null)
            this.props.toggleSelectLayer(shapeIdx)
        } else {
            if (shapeIdx === SOURCE_IMAGE_INDEX) {
                this.props.setActiveShapeId(null)
                this.props.setActiveView(ACTIVE_VIEW_EDIT_SOURCE_IMAGE)
            } else if (!this.props.lockedLayers.includes(shapeIdx)) {
                this.props.setActiveShapeId(shapeIdx)
                this.props.setActiveView(ACTIVE_VIEW_EDIT_SHAPE)
            }

            this.props.selectLayers()
        }

        this.props.setActiveGroupId(null)
    }

    handleGroupClickEvent = (group: LayerGroupType, event: MouseEvent) => {
        this.props.setActiveGroupId(group.index)
        this.props.setActiveShapeId(null)
        this.props.selectLayers(group.list)
    }

    getOrderedShapeAndGroupsListArray = (onlyIds: boolean): Iterable<ReactNode> | string[] => {
        const { randomProduct, form } = this.props

        const groups = form.groups

        let list = []
        let excludeIndexes = []

        _sortBy(Object.keys(form.shapes).map(o => form.shapes[o]), [o => new Number(o.priority)]).forEach(shape => {
            let groupToRender = null

            if (Array.isArray(groups)) {
                groups.forEach(g => {
                    if (!excludeIndexes.includes(shape.index) && g.list.includes(shape.index)) {
                        excludeIndexes.push(...g.list)
                        groupToRender = onlyIds ? g.index : <ShapeListGroupItem
                            group={g}
                            key={g.index}
                            handleClick={(g, event) => this.handleGroupClickEvent(g, event)}
                        />
                        return
                    }
                })
            }

            if (groupToRender) {
                list.push(groupToRender)
            }

            const sourceSVG = (shape.type === SOURCE_IMAGE_TYPE) ?
                <LayerPreview color={'transparent'} background={'transparent'} title={trans('source_image')}>
                    {randomProduct && randomProduct.isLoaded &&
                        <Grid cols="36px 36px" style={{ overflow: 'hidden', alignSelf: 'center' }}>
                            <GridCell style={{ alignSelf: 'center' }}>
                                {randomProduct.image_link &&
                                    <svg id="image" width={"100%"} viewBox={`0 0 10 10`} className={'source-image-preview'}>
                                        <image
                                            className="image-preview"
                                            x="0"
                                            y="0"
                                            transform={`translate(5, 5), rotate(${form.rotation}), scale(${form.flop === 1 ? -1 : 1}, ${form.flip === 1 ? -1 : 1}), translate(-5, -5)`}
                                            width={"10"}
                                            height={"10"}
                                            onClick={(e) => this.unselectShape()}
                                            xlinkHref={randomProduct.image_link}
                                        />
                                    </svg>
                                }
                            </GridCell>

                            <GridCell>
                                {randomProduct.alternative_images && randomProduct.alternative_images.map((altImage, key) => <img
                                    key={`alt${key}`}
                                    title={`alt ${key}`}
                                    src={altImage.url}
                                    style={{ maxWidth: '100%', maxHeight: '10px', display: 'block', overflow: 'hidden', paddingBottom: '1px' }}
                                />)}
                            </GridCell>
                        </Grid>
                    }

                    {shape.clip_mask &&
                        <ClipMaskForm shape={shape} onlyMask={true} />
                    }
                </LayerPreview > : null

            if (!excludeIndexes.includes(shape.index)) {
                list.push(onlyIds ? shape.index :
                    <ShapeListItem
                        data={shape}
                        key={shape.index}
                        onClick={(e: MouseEvent) => this.handleClickEvent(e, shape.index)}
                        onEdit={this.handleEditEvent}
                        sourceSVG={sourceSVG}
                        isMouseOver={this.props.mouseOverShape === shape.index}
                        setMouseOverShape={this.props.setMouseOverShape}
                    />)
            }
        })

        return list
    }

    unselectShape = () => {
        this.props.setActiveShapeId(null);
    }

    handleAddShape = () => {
        this.props.setActiveView(ACTIVE_VIEW_NEW_SHAPE)
    }

    reorderShapesAndGroupsByIndex = (list: ItemInterface[]) => {
        const { form } = this.props

        const groupsLength = form.groups && Array.isArray(form.groups) ? form.groups.length : 0

        const newOrder = list.map(i => i.id)    //mixed shape indexes and group indexes all together
        const order = this.getOrderedShapeAndGroupsListArray(true) as string[]  //get current shapes and groups order (mixed indexes)

        if (order.join(',') !== newOrder.join(',')) {   //reorder only if diffs
            let newOrderOnlyShapeIndexes = []   //no group index here

            newOrder.forEach(index => {
                if (!`${index}`.startsWith('_') && groupsLength > 0) {   //try to find group by index
                    const group = _find(form.groups, (g: LayerGroupType) => {
                        return `${index}` === `${g.index}`
                    })

                    if (group) {
                        //and then find the shape indexes for this group
                        group.list.forEach(shapeIndex => {
                            newOrderOnlyShapeIndexes.push(shapeIndex)
                        })
                    } else {
                        //this shouldn't happen
                        newOrderOnlyShapeIndexes.push(index)
                    }
                } else {
                    //either it is shape index starting with _ or sourceImage index
                    newOrderOnlyShapeIndexes.push(index)
                }
            })

            reorderShapes(form.shapes, newOrderOnlyShapeIndexes)
        }
    }

    render() {
        const { randomProduct } = this.props

        //wait for random product to load, so we don't need to reorder shapes each time.
        if (randomProduct.isLoading) {
            return <SectionLoader />
        }

        const ids = this.getOrderedShapeAndGroupsListArray(true) as string[]
        const list = ids.map(id => ({ id: id }))

        const userId = this.props.project.data?.user?.id ? this.props.project.data.user.id : null
        const isTest = testUsers.includes(userId)

        return (
            <Div margin="-20px -10px 20px -10px">
                <StyledTable isTest={isTest} className="scrollable">
                    <ReactSortable list={list} setList={this.reorderShapesAndGroupsByIndex} handle=".drag-handle" tag="tbody">
                        {this.getOrderedShapeAndGroupsListArray(false)}
                    </ReactSortable>
                </StyledTable>
            </Div>

        )
    }
}

const StyledTable = css('table')({
    width: '100%',
    ' .dynamic': {
        background: '#80bed22e',
    },
    ' .active-row': {
        background: "#c2ebef !important",
        "&:hover td": {
            background: "#c2ebef !important",
        }
    },
    ' .hidden-shape': {
        transition: "color 0.2s ease-out",
        color: iconDisabledColor,
        textDecoration: 'line-through',
    },
    ' .hidden-preview': {
        opacity: .5,
        filter: 'alpha(opacity=50)',
    },
    ' .selected-row': {
        background: "#d8f6f9",
    },
    ' @keyframes blinker': {
        ' 0%': {
            color: '#ffffff',
            background: Theme.blue + '3a',
        },
        ' 50%': {
            color: '#000000',
            background: '#ffffff',
        },
    },
}, props => {
    return {
        ' tr.mouse-over': {
            background: '#fafafa',
            animation: props.isTest ? 'blinker 1.2s linear infinite' : undefined,
            transition: 'background .5s ease-out'
        },
    }
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        randomProduct: state.randomProduct,
        activeGroupId: state.activeGroupId,
        activeShapeId: state.activeShapeId,
        lockedLayers: state.lockedLayers,
        project: state.project,
    }
}

export default connect(mapStateToProps, {
    setActiveShapeId,
    setActiveGroupId,
    setActiveView,
    toggleSelectLayer,
    selectLayers,
    change,
})(ShapeList)
